import React, { useState, useEffect } from "react";
import { Modal, Spin, Button } from "antd";
import { isEmpty, keys } from "lodash";
import { toast } from "react-toastify";
import { getPresignedURL } from "../../../../../utils/helpers";
import useAbortController from "../../../../Common/hooks/useAbortController";
import "./FilmImagePreviewModal.css";

const getPreferredFilmS3Info = (testData = {}) => (
  testData.ml_s3_info || testData.user_s3_info || null
);

const FilmImagePreviewModal = ({
  open,
  onCancel,
  testData,
  onAnnotate,
}) => {
  const [loading, setLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const { setNewAbortController } = useAbortController();
  const filmS3Info = getPreferredFilmS3Info(testData);

  const fetchImageSrc = async () => {
    setLoading(true);
    const newAbortController = setNewAbortController();

    try {
      const response = await getPresignedURL({
        action: "get",
        urls: [filmS3Info],
      }, newAbortController.signal);

      if (response.aborted) {
        setLoading(false);
        return;
      }

      if (response.success && response.result && keys(response.result).length > 0) {
        const imageUrl = response.result[keys(response.result)[0]];
        setImageSrc(imageUrl);
      } else {
        toast.error(response.message || "Failed to fetch the image");
        setLoading(false);
        return;
      }
    } catch (error) {
      if (!error.aborted) {
        toast.error("Failed to fetch the image");
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && filmS3Info) {
      fetchImageSrc();
    } else {
      setImageSrc(null);
      setNewAbortController();
    }
  }, [open, filmS3Info]); // eslint-disable-line

  const annotationImagePath = (testData && !isEmpty(testData.ml_s3_info)) ? testData.ml_s3_info : null;

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width="80vw"
      className="MarkSampleQCModal__FilmPreviewModal"
      title={(
        <div className="FilmImagePreviewModal__Header">
          <span className="FilmImagePreviewModal__HeaderTitle">Petrifilm Image</span>
          <Button
            type="primary"
            className="FilmImagePreviewModal__AnnotateBtn"
            onClick={() => onAnnotate(annotationImagePath)}
            disabled={annotationImagePath === null}
          >
            Annotate
          </Button>
        </div>
      )}
    >
      <Spin spinning={loading}>
        <div className="MarkSampleQCModal__FilmPreviewContent">
          <div className="MarkSampleQCModal__FilmPreviewImageContainer">
            {imageSrc && (
              <img
                src={imageSrc}
                onLoad={() => setLoading(false)}
                onError={() => {
                  setLoading(false);
                  toast.error("Failed to load image from S3");
                }}
                alt="Film preview"
                className="MarkSampleQCModal__FilmPreviewImage"
              />
            )}
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default FilmImagePreviewModal;
